import { render, staticRenderFns } from "./ResultSmallRoad.vue?vue&type=template&id=6b2ef80e&"
import script from "./ResultSmallRoad.vue?vue&type=script&lang=js&"
export * from "./ResultSmallRoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports